import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const ContactUsWrapper = styled.div`
  .contact-us-title {
    text-align: center;
  }

  .contact-us-form {
    max-width: 90dvw;
    width: 100%;
    margin: 20px auto;
    display: flex;
    justify-content: space-evenly;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .form-column {
    margin: 0 12px;
    max-width: 300px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .contacts-column {
    align-items: center;

    .contact-input {
      max-width: 250px;
      width: 100%;
      margin: 8px auto;
    }
  }

  .contact-message-input textarea {
    height: 270px;
    font-family: sans-serif;
    font-size: 16px;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      height: 200px;
    }
  }

  .attachment-input {
    align-self: flex-end;
  }

  .attachment-input::file-selector-button {
    margin: 20px 8px;
    padding: 4px 12px;
    border-radius: 20px;
    outline: none;
    border: none;
    background-color: ${mainColors.main_color};
    color: ${mainColors.text_color};
    cursor: pointer;
  }

  .contact-submit-button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .contact-submit-button {
      padding: 8px 20px;
      margin: 20px 0;
    }
  }
`;

export default ContactUsWrapper;
